export default {
    props: {
        vatRates: {
            type: Array,
            default: [],
        },
    },
    methods: {
        getVatRate(id) {
            return this.vatRates.find(vr => vr.id == id);
        },
        getVatRateAmount(id) {
            const vatRate = this.getVatRate(id);
            return vatRate ? parseFloat(vatRate.rate) / 100 : 0;
        }
    },
};
